import React from "react";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'
import Select from 'react-select'
import { Button } from 'react-toolbox'
import Bar from 'components/custom/Highcharts/Bar'
import Body2 from 'components/typography/body2/index'
import FulcrumDivider from 'components/fulcrum/divider/Divider'

import {
  updateProjectSpecificationQueryAction,
  addSpecificationChart,
  removeSpecificationChart
} from '../actions'
import {
  attributesEnum
} from '../constants'
import {
  projectSpecificationQuerySelector,
} from '../selectors'
import styles from '../styles.scss'

const mapStateToProps = (state) => {
  return {
    projectSpecificationQuery: projectSpecificationQuerySelector(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateProjectSpecificationQuery: (attr, index) => dispatch(updateProjectSpecificationQueryAction(attr, index)),
    addSpecificationChart: () => dispatch(addSpecificationChart()),
    removeSpecificationChart: (index) => dispatch(removeSpecificationChart(index))
  }
}

class SpecificationChart extends React.Component {
  onDelete(index) {
    this.props.removeSpecificationChart(index)
  }

  onAdd() {
    this.props.addSpecificationChart()
  }

  onUpdate(attr, index) {
    this.props.updateProjectSpecificationQuery(attr, index)
  }

  renderChart(report, attribute, index) {
    const selectOptions = Object.values(attributesEnum).reduce((results, category) => [...results, ...category.options], [])

    const options = {
      subtitle: {
        text: attribute.label
      }
    }

    return (
      <React.Fragment key={index}>
        <Flex>
          <div styleName="attributeText"> <Body2>Attribute</Body2> </div>
          <Select
            value={attribute}
            options={selectOptions}
            styleName="stretchSelect"
            onChange={(value) => this.onUpdate(value, index)}
          />
          <Button
            icon='delete'
            primary
            onClick={() => this.onDelete(index)}
          />
        </Flex>
        <Bar
          title={report.title}
          data={report.data}
          categories={report.categories}
          additionalOptions={options}
        />
        <FulcrumDivider styleName='divider' />
      </React.Fragment>
    )
  }

  renderCharts(reports) {
    const attributes = this.props.projectSpecificationQuery
    return attributes.map((attribute, index) => {
      const report = reports.find(report => report.parent === attribute.parent && report.value == attribute.value)
      return report ? this.renderChart(report, attribute, index) : null
    })
  }

  render() {
    const {
      report
    } = this.props

    return (
      <div>
        {this.renderCharts(report)}
        <Button
          flat
          primary
          label={"ADD SPECIFICATION"}
          styleName="universeAddBtn"
          onClick={() => this.onAdd()}
        />
      </div>
    );
  }
}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withConnect,
  withStyle,
)(SpecificationChart)